import HttpClienteToken from '../../services/HttpClientToken';

import { TipoConceptoJuicioProps } from '../../interfaces/catalogos/TipoConceptoJuicioInterface';
import { TipoConceptoProps } from '../../interfaces/catalogos/TipoConceptoInterface';

export const TiposConceptoJuicio = () => {
    return new Promise<TipoConceptoJuicioProps[]>( (resolve, reject) => {
        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            HttpClienteToken.get('/Api/TipoConceptoJuicio/', token)
            .then(({ data }: { data: TipoConceptoJuicioProps[] }) => {
                resolve(data);
            })
            .catch(() => {
                resolve([]);
            });
        } else {
            resolve([]);
        }
    });
};

export const ObtenerTipoConceptoJuicios = () => {
    return new Promise<TipoConceptoJuicioProps[]>( (resolve, reject) => {
        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            HttpClienteToken.get('/Api/TipoConceptoJuicio/ObtenerTipoConceptoJuicios', token)
            .then(({ data }: { data: TipoConceptoJuicioProps[] }) => {
                resolve(data);
            })
            .catch(() => {
                resolve([]);
            });
        } else {
            resolve([]);
        }
    });
};

export const ObtenerTipoConceptoPorJuicio = ( id: number ) => {
    return new Promise<TipoConceptoProps[]>( (resolve, reject) => {
        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            HttpClienteToken.get(`/Api/TipoConceptoJuicio/ObtenerTipoConceptoPorJuicio/${ id }`, token)
            .then(({ data }: { data: TipoConceptoProps[] }) => {
                resolve(data);
            })
            .catch(() => {
                resolve([]);
            });
        } else {
            resolve([]);
        }
    });
};

export const ActualizarTipoConceptoJuicio = (params: TipoConceptoJuicioProps) => {
    return new Promise<TipoConceptoJuicioProps>( (resolve, reject) => {
        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            HttpClienteToken.post('/Api/TipoConceptoJuicio/Actualizar', params, token)
            .then(({ data }: { data: TipoConceptoJuicioProps }) => {
                resolve(data);
            })
            .catch(() => {
                resolve({
                    idTipoConceptoJuicio: 0,
                    idTipoConcepto: 0,
                    idTipoJuicio: 0,
                    activo: false,
                });
            });
        }
    });
};

export const AgregarTipoConceptoJuicio = (params: TipoConceptoJuicioProps) => {
    return new Promise<TipoConceptoJuicioProps>( (resolve, reject) => {
        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            HttpClienteToken.post('/Api/TipoConceptoJuicio/Agregar', params, token)
            .then(({ data }: { data: TipoConceptoJuicioProps }) => {
                resolve(data);
            })
            .catch(() => {
                resolve({
                    idTipoConceptoJuicio: 0,
                    idTipoConcepto: 0,
                    idTipoJuicio: 0,
                    activo: false,
                });
            });
        }
    });
};
